import { Button, Flex, Text } from "@chakra-ui/react";
import { PropostasFilterProps, UseTabelaPropostaFilterReturn } from "../utils";
import { RepeatIcon, Search2Icon } from "@chakra-ui/icons";
import { InputField } from "components/input-field";
import { DropdownField } from "components/dropdown-field";
import { useApplicationContext } from "contexts/ApplicationContext";
import { isUserGerente } from "utils/is-gerente";
import { InputBoxSearch } from "components/input-box-search";
import { Dispatch, SetStateAction, useEffect } from "react";
import { useFilterEmpresa } from "components/usuarios-bancos-components/utils";
import { PropostasFilter } from "./filter-button";

export function FilterAbaProposta({
  filterControl,
  setCustomerId,
}: {
  filterControl: UseTabelaPropostaFilterReturn;
  setCustomerId: Dispatch<SetStateAction<number | undefined>>;
  onChange: (
    value: any,
    key: keyof PropostasFilterProps,
    params?: {
      update: boolean;
    }
  ) => void;
}) {
  const { filter, isLoading, onChange, onSearch } = filterControl;
  let { empresas, loadingEmpresas, onChangeEmpresa, selectedEmpresa } =
    useFilterEmpresa({
      onChange: (customerId) => {
        setCustomerId(customerId);
      },
    });
  const { user } = useApplicationContext();
  const isGerente = isUserGerente(user);

  useEffect(() => {
    onChangeEmpresa(user.userData.customerId);
  }, []);

  return (
    <Flex
      alignItems="center"
      px="30px"
      py="8px"
      borderBottom={`1px solid #E8EAED`}
      justifyContent="space-between"
    >
      <Flex alignItems="center">
        <InputField
          leftIcon={<Search2Icon />}
          inputProps={{
            placeholder: "Pesquisar ADE",
            w: "320px",
            onKeyDown: (e) => {
              if (
                e.key === "Enter" &&
                e.currentTarget.value.trim() &&
                !isLoading
              ) {
                onSearch();
              }
            },
          }}
          onChange={(e) => onChange(e.target.value, "ade", { update: false })}
          value={filter.ade}
        />
        <Button
          leftIcon={<Search2Icon />}
          mx="10px"
          size="sm"
          variant="outline"
          onClick={() => onSearch()}
          isLoading={isLoading}
          loadingText="Pesquisando"
          isDisabled={!filter.ade?.trim()}
        >
          Pesquisar
        </Button>
        <Button
          mr="10px"
          leftIcon={<RepeatIcon />}
          onClick={() => filterControl.onSearch()}
        >
          Atualizar
        </Button>
        <Flex alignItems="center" mr="10px">
          <Text mr="10px" fontWeight="semibold">
            Convenios:
          </Text>
          <DropdownField
            onChange={(value) => onChange(value, "convenio")}
            value={filter.convenio}
            options={[
              { name: "INSS", value: "INSS" },
              { name: "Antecipação FGTS", value: "ANTECIPACAO_FGTS" },
            ]}
          />
        </Flex>
      </Flex>
      <Flex alignItems="center">
        {isGerente ? (
          <Flex alignItems="center" ml="auto" w="370px">
            <Text mr="10px" fontWeight="semibold">
              Empresas:
            </Text>
            <InputBoxSearch
              isLoading={loadingEmpresas}
              options={empresas}
              onChange={(value) => {
                onChangeEmpresa(value);
              }}
              checkIsInclude={(option) => selectedEmpresa === option.value}
              isDisabled={loadingEmpresas}
              openOnFocus
              resultLimit={Infinity}
              partialSearch
              value={
                empresas.find((curr) => curr.value === selectedEmpresa)?.name ||
                ""
              }
              inputBoxProps={{
                onFocus: (e) => {
                  e.currentTarget.textContent = "";
                },
                onBlur: (e) => {
                  e.currentTarget.textContent =
                    empresas.find((curr) => curr.value === selectedEmpresa)
                      ?.name || "";
                },
              }}
            />
          </Flex>
        ) : null}
        <PropostasFilter
          filter={filter}
          isLoading={isLoading}
          onChange={onChange}
          errors={filterControl.errors}
          onSearch={onSearch}
        />
      </Flex>
    </Flex>
  );
}
